import * as React from "react";
import { TaskTreeEditor } from "./TaskTreeEditor";
import { Header } from "src/components/Header";
import { Page } from "src/components/Page";
import { useLiveQuery } from "dexie-react-hooks";
import { PlusIcon } from "lucide-react";
import { Tree } from "src/utils/Tree";
import { moveItem } from "src/database/queries/items";
import { getBacklog } from "src/database/queries/tasks";
import { taskFormContext } from "./TaskForm/taskFormContext";
import { createEmptyTask } from "src/database/factories";
import { Ordering } from "src/database/models/Ordering";

export function Backlog() {
  const taskForm = React.useContext(taskFormContext);
  const initialTasks = useLiveQuery(() => getBacklog());
  const tasks = Tree.build(initialTasks ?? []);

  return (
    <Page maxWidth={600}>
      <Header title="Backlog">
        <Header.Button
          icon={PlusIcon}
          onClick={() =>
            taskForm.create(
              createEmptyTask({
                order: Ordering.insertAt(tasks, (t) => t.order, 0),
              }),
            )
          }
        >
          New Task
        </Header.Button>
      </Header>
      <TaskTreeEditor items={tasks} collapse onMoveItem={moveItem} />
    </Page>
  );
}
